import { useContext, useRef } from 'react';
import { unstable_batchedUpdates } from 'react-dom';
import { useIntl } from 'react-intl';
import {
  useEventCallback,
  SnackbarContext,
  AbortableFetch,
  SnackbarVariant,
  CrudSource,
} from '@eas/common-web';
import { Registration } from '../../../common/models';
import { confirmRegistration } from './registrations-api';

export function useRegistrationsToolbar({
  source,
  onPersisted,
}: {
  source: CrudSource<Registration>;
  onPersisted: (id: string | null) => void;
}) {
  const intl = useIntl();
  const { showSnackbar } = useContext(SnackbarContext);
  const fetch = useRef<AbortableFetch | null>(null);

  const confirm = useEventCallback(async () => {
    try {
      source.setLoading(true);
      if (fetch.current !== null) {
        fetch.current.abort();
      }

      fetch.current = confirmRegistration(source.data!.id);

      await fetch.current.none();

      const message = intl.formatMessage({
        id: 'KS_O_REGISTRATIONS_MSG_CONFIRM_SUCCESS',
        defaultMessage: 'Registrace byla úspěšně potvrzena.',
      });

      unstable_batchedUpdates(() => {
        showSnackbar(message, SnackbarVariant.SUCCESS);
        source.setLoading(false);
      });

      onPersisted(source.data!.id);
      await source.refresh();
    } catch (err) {
      source.setLoading(false);

      if (err.name !== 'AbortError') {
        const message = intl.formatMessage(
          {
            id: 'KS_O_REGISTRATIONS_MSG_CONFIRM_ERROR',
            defaultMessage: 'Chyba volání funkce: {detail}',
          },
          { detail: err.message }
        );

        showSnackbar(message, SnackbarVariant.ERROR);

        throw err;
      }
      return undefined;
    }
  });

  return { confirm };
}
